<template>
  <Modal :id="id" :modalTitle="modalTitle" :class="classes" :onClose="onClose">
    <div class="row" style="margin-bottom: 20px">
      <div class="col-12">
        <div class="generalTitleItemModal">
          Se van a añadir los siguientes parámetros a la Black List:
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-2">
        <div class="generalTitleItemModal">Email:</div>
      </div>
      <div class="col-4">
        <div>{{ $props.email }}</div>
      </div>
      <div class="col-6">
        <img
          v-if="emailLoading"
          src="../../../../../assets/loaderPrimary.svg"
          height="30"
          alt=""
        />
        <div v-if="emailSuccess" class="form-text text-success">
          {{ textSuccess }}
        </div>
        <div v-if="emailError" class="form-text text-danger">
          {{ textError }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-2">
        <div class="generalTitleItemModal">DNI:</div>
      </div>
      <div class="col-4">
        <div>{{ $props.legalIdentifier }}</div>
      </div>
      <div class="col-6">
        <img
          v-if="legalIdentifierLoading"
          src="../../../../../assets/loaderPrimary.svg"
          height="30"
          alt=""
        />
        <div v-if="legalIdentifierSuccess" class="form-text text-success">
          {{ textSuccess }}
        </div>
        <div v-if="legalIdentifierError" class="form-text text-danger">
          {{ textError }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-2">
        <div class="generalTitleItemModal">Teléfono:</div>
      </div>
      <div class="col-4">
        <div>{{ $props.phone }}</div>
      </div>
      <div class="col-6">
        <img
          v-if="phoneLoading"
          src="../../../../../assets/loaderPrimary.svg"
          height="30"
          alt=""
        />
        <div v-if="phoneSuccess" class="form-text text-success">
          {{ textSuccess }}
        </div>
        <div v-if="phoneError" class="form-text text-danger">
          {{ textError }}
        </div>
      </div>
    </div>
    <div class="row" v-if="!launched">
      <div class="col-12">
        <button
          class="btn btn-primary generalPrimaryButton float-right"
          @click="addBlackList()"
        >
          Confirmar
        </button>
      </div>
    </div>
    <button
      :id="id + 'CierreModal'"
      style="display: none"
      data-dismiss="modal"
    />
  </Modal>
</template>


<script>
import Modal from "../../../Shared/Modal.vue";
import axios from "axios";
export default {
  name: "addBL",
  props: ["id", "modalTitle", "class", "email", "legalIdentifier", "phone"],
  data() {
    return {
      classes: this.class,
      textSuccess: "Añadido a la Black List correctamente.",
      textError: "Ha ocurrido un error o ya estaba en la Black List.",
      launched: false,
      emailLoading: false,
      emailSuccess: false,
      emailError: false,
      legalIdentifierLoading: false,
      legalIdentifierSuccess: false,
      legalIdentifierError: false,
      phoneLoading: false,
      phoneSuccess: false,
      phoneError: false,
    };
  },
  components: {
    Modal,
  },
  methods: {
    addBlackList() {
      this.launched = true;
      this.emailLoading = true;
      this.legalIdentifierLoading = true;
      this.phoneLoading = true;

      axios
        .post("/customer/blacklist-save", { email: this.email })
        .then(() => {
          this.emailLoading = false;
          this.emailSuccess = true;
        })
        .catch(() => {
          this.emailLoading = false;
          this.emailError = true;
        });
      axios
        .post("/customer/blacklist-save", {
          legalIdentifier: this.legalIdentifier,
        })
        .then(() => {
          this.legalIdentifierLoading = false;
          this.legalIdentifierSuccess = true;
        })
        .catch(() => {
          this.legalIdentifierLoading = false;
          this.legalIdentifierError = true;
        });
      axios
        .post("/customer/blacklist-save", { mobile: this.phone })
        .then(() => {
          this.phoneLoading = false;
          this.phoneSuccess = true;
        })
        .catch(() => {
          this.phoneLoading = false;
          this.phoneError = true;
        });
    },
    onClose() {
      document.querySelector(`#${this.id}CierreModal`).click();
      this.$emit("closeModal", "");
    },
  },
};
</script>

<style lang="scss"></style>
